import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Version } from "../otros/Versiones";

import Logo from "../../img/logo.png";

const navSections = [
  {
    label: "Solicitudes",
    items: [
      {
        to: "/admin/crear-solicitud",
        icon: "fa-solid fa-plus",
        text: "Crear solicitud",
      },
      {
        to: "/admin/mis-solicitudes",
        icon: "fa-solid fa-list-check",
        text: "Solicitudes de trabajo",
      },
      {
        to: "/admin/solicitud-planificado",
        icon: "fa-solid fa-calendar-check",
        text: "Mant. Planificado",
      },
      {
        to: "/admin/solicitud-planificado-2",
        icon: "fa-solid fa-clipboard-list",
        text: "Mant. Programado",
      },
      {
        to: "/admin/solicitud-pedimentos",
        icon: "fa-solid fa-file-lines",
        text: "Pedimentos",
      },
    ],
  },
  {
    label: "Administración",
    items: [
      {
        to: "/admin/usuarios",
        icon: "fa-solid fa-users",
        text: "Usuarios",
      },
      {
        to: "/admin/datos-maestros/clasificaciones",
        icon: "fa-solid fa-tags",
        text: "Tipos de trabajos",
      },
      {
        to: "/admin/datos-maestros/activos",
        icon: "fa-solid fa-ship",
        text: "Activos",
      },
      {
        to: "/admin/sistemas",
        icon: "fa-solid fa-gears",
        text: "Sistemas y Equipos",
      },
    ],
  },
];

const AdminSidebar = () => {
  let navigate = useNavigate();
  const location = useLocation();

  let { user } = useSelector((state) => ({ ...state }));
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const resizeListener = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", resizeListener);
    return () => window.removeEventListener("resize", resizeListener);
  }, []);

  useEffect(() => {
    if (windowWidth > 800) {
      const body = document.querySelector("body"),
        sidebar = body.querySelector(".sidebar"),
        toggle = body.querySelector(".toggle"),
        modeSwitch = body.querySelector(".toggle-switch"),
        modeText = body.querySelector(".mode-text");

      modeSwitch.addEventListener("click", () => {
        body.classList.toggle("dark");
      });

      toggle.addEventListener("click", () => {
        sidebar.classList.toggle("cls");
      });
    }
  }, [windowWidth]);

  const dispatch = useDispatch();

  const logout = () => {
    dispatch({ type: "LOGOUT", payload: null });
    navigate("/");
  };

  const isActive = (path) => location.pathname === path;

  const activeStyle = {
    background: "var(--primary-color)",
    color: "#fff",
    borderRadius: "6px",
  };

  const activeIconTextStyle = {
    color: "#fff",
  };

  const sectionLabelStyle = {
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "#94a3b8",
    padding: "16px 20px 4px 20px",
    margin: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
  };

  const renderNavItems = () =>
    navSections.map((section, sIdx) => (
      <React.Fragment key={sIdx}>
        <li style={{ height: "auto", margin: 0, padding: 0 }}>
          <p style={sectionLabelStyle} className="text">
            {section.label}
          </p>
        </li>
        {section.items.map((item) => (
          <li className="nav-link" key={item.to}>
            <Link to={item.to} style={isActive(item.to) ? activeStyle : {}}>
              <i
                className={`${item.icon} icon`}
                style={isActive(item.to) ? activeIconTextStyle : {}}
              ></i>
              <span
                className="text nav-text"
                style={{
                  fontSize: "12px",
                  ...(isActive(item.to) ? activeIconTextStyle : {}),
                }}
              >
                {item.text}
              </span>
            </Link>
          </li>
        ))}
      </React.Fragment>
    ));

  // Desktop sidebar
  if (windowWidth > 800) {
    return (
      <nav className="sidebar">
        <header>
          <div className="image-text">
            <span className="image">
              <img src={Logo} alt="Logo" />
            </span>
            <div className="text header-text ml-2">
              <span className="name">{user.nombre}</span>
              <span className="subtitle">Napsom V {Version}</span>
            </div>
          </div>
          <i className="fa-solid fa-angle-right toggle"></i>
        </header>

        <div className="menu-bar">
          <div className="menu">
            <ul className="menu-links">{renderNavItems()}</ul>
          </div>
          <div className="bottom-content">
            <li>
              <Link onClick={logout}>
                <i className="fa-solid fa-right-from-bracket icon"></i>
                <span className="text nav-text">Desconectarse</span>
              </Link>
            </li>
            <li className="mode">
              <div className="moon-sun">
                <i className="fa-solid fa-moon icon moon"></i>
                <i className="fa-solid fa-sun icon sun"></i>
              </div>
              <span className="mode-text text">Dark Mode</span>
              <div className="toggle-switch">
                <span className="switch"></span>
              </div>
            </li>
          </div>
        </div>
      </nav>
    );
  }

  // Mobile sidebar
  return (
    <>
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src={Logo} style={{ width: "40px" }} alt="Logo" />
          <span
            style={{
              fontSize: "13px",
              fontWeight: 700,
              color: "#1b2a4a",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Napsom
          </span>
        </div>
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          style={{
            background: "none",
            border: "none",
            fontSize: "22px",
            color: "#1b2a4a",
            cursor: "pointer",
            padding: "4px 8px",
          }}
        >
          <i
            className={mobileOpen ? "fa-solid fa-xmark" : "fa-solid fa-bars"}
          ></i>
        </button>
      </nav>

      {/* Overlay */}
      {mobileOpen && (
        <div
          onClick={() => setMobileOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.3)",
            zIndex: 1001,
          }}
        />
      )}

      {/* Slide-in drawer */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          width: "280px",
          background: "#fff",
          zIndex: 1002,
          transform: mobileOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.25s ease",
          display: "flex",
          flexDirection: "column",
          boxShadow: mobileOpen ? "4px 0 20px rgba(0,0,0,0.12)" : "none",
        }}
      >
        {/* Drawer header */}
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #eef0f3",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <img src={Logo} style={{ width: "44px" }} alt="Logo" />
          <div>
            <div
              style={{
                fontSize: "13px",
                fontWeight: 700,
                color: "#1b2a4a",
                textTransform: "uppercase",
              }}
            >
              {user.nombre}
            </div>
            <div style={{ fontSize: "11px", color: "#94a3b8" }}>
              Napsom V {Version}
            </div>
          </div>
        </div>

        {/* Drawer nav */}
        <div style={{ flex: 1, overflowY: "auto", padding: "8px 0" }}>
          {navSections.map((section, sIdx) => (
            <React.Fragment key={sIdx}>
              <p
                style={{
                  fontSize: "10px",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  color: "#94a3b8",
                  padding: "14px 20px 4px 20px",
                  margin: 0,
                }}
              >
                {section.label}
              </p>
              {section.items.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMobileOpen(false)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px 20px",
                    fontSize: "13px",
                    fontWeight: isActive(item.to) ? 600 : 400,
                    color: isActive(item.to) ? "#fff" : "#334155",
                    background: isActive(item.to)
                      ? "var(--primary-color)"
                      : "transparent",
                    borderRadius: "6px",
                    margin: "2px 12px",
                    textDecoration: "none",
                    transition: "background 0.15s",
                  }}
                >
                  <i
                    className={item.icon}
                    style={{
                      width: "20px",
                      textAlign: "center",
                      fontSize: "14px",
                      color: isActive(item.to) ? "#fff" : "#64748b",
                    }}
                  ></i>
                  {item.text}
                </Link>
              ))}
            </React.Fragment>
          ))}
        </div>

        {/* Drawer footer */}
        <div style={{ borderTop: "1px solid #eef0f3", padding: "12px" }}>
          <button
            onClick={() => {
              setMobileOpen(false);
              logout();
            }}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "10px 12px",
              fontSize: "13px",
              fontWeight: 500,
              color: "#ef4444",
              background: "#fef2f2",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            <i
              className="fa-solid fa-right-from-bracket"
              style={{ fontSize: "14px" }}
            ></i>
            Desconectarse
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar;
